module.exports = __webpack_public_path__ + "static/media/circular-std-medium-500.9475d6a0.ttf";